// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"5fd38056","215":"9788d616","484":"f2ae6e0a","522":"4dfe017d","593":"a58e55ad","603":"e6e928b0","726":"8885dc9a","906":"3a477719","924":"7d6e9499"}[chunkId] + ".chunk.js";
};